module.exports = __webpack_public_path__ + "img/signage_control_off.145ffa94.png";